import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TimeApiService } from 'cbc-shared-lib';
import { takeUntil } from 'rxjs/operators';
import { UsedSzza012aService } from '../../../../../sg-kd-shared/services/used-szza012a.service';
import { UsedSgkd010dSgkd030aService } from '../../services/used-sgkd010d-sgkd030a.service';
import { Sgkd030aResponseAccounttransferrequestReturninfo } from 'sg-api';
import { SgKdConstants } from '../../../../../sg-kd-shared/sg-kd-constants';
import { UsedSgkd010dSgkd042aService } from '../../services/used-sgkd010d-sgkd042a.service';

@Component({
  selector: 'app-sgkd010d-search-condition',
  templateUrl: './sgkd010d-search-condition.component.html',
  styleUrl: './sgkd010d-search-condition.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkd010dSearchConditionComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 検索条件フォーム */
  conditionForm: UntypedFormGroup;

  /** レスポンスエミッター */
  @Output() responseEmitter = new EventEmitter<[Array<Sgkd030aResponseAccounttransferrequestReturninfo>, string]>();
  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();

  /** 業務日付 */
  businessDate: string;
  /** 業務日付 */
  dateBusinessDate: Date
  /** 口座振替日開始日付 */
  kouzaFrikaeDateStDate: Date;
  /** 依頼返却締切日開始日付 */
  reqReturnDeadlineStDate: Date;

  /** 検索結果 */
  resultList: Array<Sgkd030aResponseAccounttransferrequestReturninfo> = [];

  constructor(
    private parent: FormGroupDirective,
    private formBuilder: UntypedFormBuilder,
    private usedSzza012aService: UsedSzza012aService,
    private timeApiService: TimeApiService, 
    private usedSgkd010dSgkd030aService: UsedSgkd010dSgkd030aService, 
    private usedSgkd010dSgkd042aService: UsedSgkd010dSgkd042aService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd010dSearchConditionComponent
   */
  ngOnInit(): void {
    this.mainForm = this.parent.form;
    this.conditionForm = this.createForm();
    this.mainForm.addControl('conditionForm', this.conditionForm);
    // 業務日付取得
    this.usedSzza012aService.doSzza012a()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.businessDate = response.todayDay;
        this.dateBusinessDate = this.timeApiService.convertStringToDate(this.businessDate);
        this.kouzaFrikaeDateStDate = this.dateBusinessDate;
        this.reqReturnDeadlineStDate = this.dateBusinessDate;
      }, error => {
      });
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd010dSearchConditionComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
    if (this.mainForm) {
      this.mainForm.clearValidators();
      this.mainForm.updateValueAndValidity();
      this.mainForm.removeControl('conditionForm');
    }
  }

  /**
   * 依頼返却金融機関名検索
   * 
   * @memberof Sgkd010dSearchConditionComponent
   */
  searchBankNm(): void {

    this.clearMessageEvent.emit('');

    this.conditionForm.get('reqretBankfcMei').setValue(SgKdConstants.STR.EMPTY);

    if (this.conditionForm.get('reqretBankfcCode').value === SgKdConstants.STR.EMPTY ||
        !this.conditionForm.get('reqretBankfcCode').valid) {
      return;
    }

    this.usedSgkd010dSgkd042aService.select(this.conditionForm.get('reqretBankfcCode')?.value)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        response => {
          this.conditionForm.get('reqretBankfcMei').setValue(
            response.responseDto.reqretFinancialinstitutionname);
        }, error => {
        }
      );
  }

  /**
   * 検索ボタン押下処理
   * 
   * @memberof Sgkd010dSearchConditionComponent 
   */
  onClickSearch(): void {

    this.clearMessageEvent.emit('');

    let frikaedate = '';
    if (this.conditionForm.get('kouzaFrikaeDate').value) {
      frikaedate = this.timeApiService.convertDateToString(this.conditionForm.get('kouzaFrikaeDate').value);
    }
    let reqretDeadline = '';
    if (this.conditionForm.get('reqReturnDeadline').value) {
      reqretDeadline = this.timeApiService.convertDateToString(this.conditionForm.get('reqReturnDeadline').value);
    }
    let reqretFinancialinstitutioncode = this.conditionForm.get('reqretBankfcCode').value;
    let outputfinishRequestreturndisplayFlg = '';
    if (this.conditionForm.get('cbOutputfinishReqretHyoji').value) {
      outputfinishRequestreturndisplayFlg = SgKdConstants.FLG.ON;
    } else {
      outputfinishRequestreturndisplayFlg = SgKdConstants.FLG.OFF;
    }

    // 口座振替依頼返却情報一覧取得
    this.usedSgkd010dSgkd030aService.select(frikaedate, reqretDeadline, reqretFinancialinstitutioncode, outputfinishRequestreturndisplayFlg)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        this.resultList = response.responseDto.accounttransferrequestReturninfoLst;
        this.responseEmitter.emit([this.resultList, outputfinishRequestreturndisplayFlg]);
      }, error => {
      });
  }

  /**
   * クリアボタン押下処理
   * 
   * @memberof Sgkd010dSearchConditionComponent 
   */
  onClickClear(): void {
    this.conditionForm.get('kouzaFrikaeDate').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('reqReturnDeadline').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('reqretBankfcCode').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('reqretBankfcMei').setValue(SgKdConstants.STR.EMPTY);
    this.conditionForm.get('cbOutputfinishReqretHyoji').setValue(false);
  }

  /**
   * 検索ボタン活性制御
   * 
   * @returns 非活性の場合true/活性の場合false
   * @memberof Sgkd010dSearchConditionComponent 
   */
  disabledBtnSearch(): boolean {
    if (this.isNullOrEmpty(this.conditionForm.get('kouzaFrikaeDate')?.value) &&
        this.isNullOrEmpty(this.conditionForm.get('reqReturnDeadline')?.value)) {
      return true;
    }
    if (!this.conditionForm.get('reqretBankfcCode')?.valid) {
      return true;
    }
    return false;
  }

  private isNullOrEmpty(value: string): boolean {
    return value === null || value === undefined || value === SgKdConstants.STR.EMPTY;
  }

  /**
   * フォームの生成
   * 
   * @returns 本コンポーネントのForm情報
   * @memberof Sgkd010dSearchConditionComponent
   */
  private createForm(): UntypedFormGroup {
    let form = this.formBuilder.group({
      /** 口座振替日 */
      kouzaFrikaeDate: new UntypedFormControl(
        { value: '', disabled: false }),
      /** 依頼返却締切日 */
      reqReturnDeadline: new UntypedFormControl(
        { value: '', disabled: false }),
      /** 依頼返却金融機関コード */
      reqretBankfcCode: new UntypedFormControl(
        { value: '', disabled: false },
        [
          Validators.maxLength(SgKdConstants.SGKD010D.MAX_LENGTH.EXT_BANKFC_CODE),
          Validators.minLength(SgKdConstants.SGKD010D.MAX_LENGTH.EXT_BANKFC_CODE)
        ]),
      /** 依頼返却金融機関名 */
      reqretBankfcMei: new UntypedFormControl(
        { value: '', disabled: true }),
      /** 出力済依頼返却表示 */
      cbOutputfinishReqretHyoji: new UntypedFormControl(
        { value: false, disabled: false })
    });
    return form;
  }
}
